import styled from 'styled-components';

export const CardInputWrapper = styled.div`
  padding: 10px 6px;
  background-color: #fff;
  margin-bottom: 15px;
  border: 1px solid #eee;
  border-radius: 5px;
`;

export const BlueButton = styled.button`
  max-width: 382px;
  width: 100%;
  height: 55px;
  border-radius: 5px;
  box-shadow: 0 5px 4px 0 rgba(0, 0, 0, 0.18);
  background-color: #39a2db;
  color: white;
  font-size: 16px;
`;
